import { Fragment, useState, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";

import dynamic from 'next/dynamic'
 
const DynamicSketch = dynamic(() => import('./Sketch'), {
  loading: () => <p>Loading...</p>,
})

export default function SketchDialog(props) {
    const [open, setOpen] = useState(true);

    useEffect(() => {
        if (!open) {
            props?.onClose?.();
        }
    }, [open, props, props.onClose]);

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={setOpen}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-ggray-100 dark:bg-gray-950 text-left shadow-xl transition-all sm:p-8 sm:max-w-4xl flex flex-col items-center justify-center">
                                <div className="text-gray-700 dark:text-gray-300 text-sm mb-3 my-3 sm:mt-0">Draw a sketch to guide the AI</div>
                                <DynamicSketch
                                    sketchState={props.sketchState}
                                    onSave={(data) => {
                                        props?.onSave?.(data);
                                        setOpen(false);
                                    }}
                                />
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}
